const formatNumberWithCommas = (number) => {
    // Convert the number to a string

    
    const numberString = number.toString();
    
    // Split the string into parts separated by every three digits from the end
    const parts = [];
    for (let i = numberString.length - 1, j = 0; i >= 0; i--, j++) {
        if (j > 0 && j % 3 === 0) {
            parts.unshift(',');
        }
        parts.unshift(numberString[i]);
    }
    
    // Join the parts together to form the formatted number
    return parts.join('');
}


export default formatNumberWithCommas